import { useState, useEffect, useContext } from 'react'
import { AuthContext } from 'exports'
import i18n, { getMainLng } from 'i18n'
import { getSubFromClaims } from 'auth/utils/auth-util'
import { getWebchatConfig, getWebchatScriptConfig } from 'utils/webchatHelper'
import MyPagesCustomerInfoContext from 'contexts/MyPagesCustomerInfoContext'

function WebChat() {
    const [webchatLoaded, setWebchatLoaded] = useState(false)
    const { isAuthenticated } = useContext(AuthContext)
    const [language, setLanguage] = useState(i18n.language)
    const [sub, setSub] = useState<any>(null)

    const { customer } = useContext(MyPagesCustomerInfoContext)
    
    i18n.on('languageChanged', (lng) => {
        setLanguage(lng)
    })

    const webchatScriptConfig = getWebchatScriptConfig();

    useEffect(() => {
        if(webchatScriptConfig){
            var scr = document.createElement("script");
            scr.src = webchatScriptConfig.src;
            scr.id = "cvc-c";
            scr.setAttribute("data-cc", webchatScriptConfig.data_cc);
            scr.setAttribute("data-ic", webchatScriptConfig.data_ic);
            scr.onload = () => setWebchatLoaded(true)
            document.head.appendChild(scr);
        }
        
        return () => {
            if(webchatScriptConfig)
                document.head.removeChild(scr);
        }
      }, []);

      async function fetchSub() {
        var claimsSub = await getSubFromClaims()
        setSub(claimsSub)
      }

      function setVisible(visibility: boolean) {
        window.cvc?.setVisible(visibility)
        //Sinch fails to hide the icon so we need to modify the style of their element in order to not display the icon when there is no user logged
        const chatDiv = document.getElementById("cvc-container")
        if(chatDiv)
            chatDiv.style.display = visibility ? 'block' : 'none'
      }

      useEffect(() => {
        if(webchatScriptConfig){
            fetchSub()
            if(webchatLoaded === true && sub && window.cvc && language){
                const langKey = getMainLng(language)
                const langConfig = getWebchatConfig(langKey)

                if(langConfig){
                    if(langConfig.translationFileUrl){
                        window.cvc.setLanguage(langConfig.langKey, langConfig.translationFileUrl)
                    }
                    else{
                        window.cvc.setLanguage(langConfig.langKey)
                    }
                    
                    window.cvc.setQueues([{"address":langConfig.queuesAddress}])
                    window.cvc.setCad({source:langConfig.source, sourcelanguage:langConfig.langKey.toUpperCase(),ssn:sub})
                    
                    if(customer){
                        const customerName = customer?.personalInfo?.firstName + " " + customer?.personalInfo?.lastName
                        const customerEmail = customer?.contacts?.email
                        if(customerName && customerEmail)
                            window.cvc.setUser(customerName,customerEmail)
                    }
                    
                    setVisible(true)
                }
            }
            else{
                setVisible(false)
            }
        }
      }, [webchatLoaded, isAuthenticated, language, customer]);

      return null
}

export default WebChat